import isValueDifferent from "./isValueDifferent";
import type { Product } from "src/@types/product";

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export function sortOnlyUpdatedData(data: Product[], dbData: any) {
	return data.map((item) => {
		// biome-ignore lint/suspicious/noExplicitAny: <explanation>
		const dbItem = dbData?.find((db: any) => db[0].id === item.id);

		return (Object.keys(item) as (keyof Product)[]).reduce(
			(acc, key) => {
				if (key === "metadata" && Array.isArray(item.metadata)) {
					const updatedMetadata = item.metadata.reduce((metaAcc, meta) => {
						if (meta.value === "") {
							meta.value = "NC";
						}

						const existingMeta = dbItem?.[0]?.metadata?.find(
							// biome-ignore lint/suspicious/noExplicitAny: <explanation>
							(m: any) => m.key === meta.key,
						);
						if (
							(existingMeta && existingMeta.value !== meta.value) ||
							(!existingMeta && meta.value !== "")
						) {
							metaAcc = metaAcc ? [...metaAcc, meta] : [meta];
						}

						return metaAcc;
						// biome-ignore lint/suspicious/noExplicitAny: <explanation>
					}, [] as any[]);

					if (updatedMetadata.length > 0) {
						acc.metadata = updatedMetadata;
					}
				} else if (key === "variants" && Array.isArray(item.variants)) {
					const updatedVariants = item.variants.reduce(
						(variantAcc, variant) => {
							const existingVariant = dbItem?.[0]?.variants?.find(
								// biome-ignore lint/suspicious/noExplicitAny: <explanation>
								(dbVariant: any) => dbVariant.id === variant.id,
							);

							if (!existingVariant) {
								// If there's nothing in the DB, we keep the variant as it is
								variantAcc.push(variant);
								return variantAcc;
							}

							const completedVariant = { ...variant };

							let hasDifference = false;

							// We check all the fields in the DB to see which ones are missing or different
							for (const key of Object.keys(existingVariant)) {
								const fromItem =
									completedVariant[key as keyof typeof completedVariant];
								const fromDb =
									existingVariant[key as keyof typeof existingVariant];

								if (fromItem === undefined || fromItem === null) {
									(completedVariant as Record<string, any>)[key] = fromDb;
									hasDifference = true;
								} else if (isValueDifferent(String(fromItem), String(fromDb))) {
									hasDifference = true;
								}
							}

							if (hasDifference) {
								variantAcc.push(completedVariant);
							}

							return variantAcc;
						},
						[] as typeof item.variants,
					);

					if (updatedVariants.length > 0) {
						acc.variants = updatedVariants;
					}

					if (updatedVariants.length > 0) {
						acc.variants = updatedVariants;
					}
				} else {
					acc[key] = item[key];
				}

				return acc;
			},
			{} as Partial<Product>,
		);
	});
}
